import React from 'react';
import { Play, Pause, RotateCcw } from 'lucide-react';

const BatteryIndicators = ({ reserveCapacity, timeToFailure, isPlaying, onPlayPause, onRestart }) => {
  const getDangerLevel = () => {
    if (reserveCapacity >= 60) return 'good';
    if (reserveCapacity >= 35) return 'caution';
    return 'danger';
  };
  
  const getDangerColor = () => {
    const level = getDangerLevel();
    if (level === 'good') return '#10b981'; // green
    if (level === 'caution') return '#f59e0b'; // orange
    return '#ef4444'; // red
  };

  return (
    <div className="flex flex-col h-full justify-center space-y-6" style={{ zIndex: 15 }}>
      {/* Reserve capacity thermometer - spans full height */}
      <div className="bg-black/50 backdrop-blur-sm rounded-lg p-4 border border-gray-600 flex-1 flex flex-col justify-center">
        <div className="text-sm text-gray-300 font-bold mb-4 text-center">RESERVE CAPACITY</div>
        <div className="w-8 flex-1 bg-gray-700 rounded-full relative overflow-hidden mx-auto min-h-[300px]">
          {/* Progress bar */}
          <div 
            className="absolute bottom-0 w-full transition-all duration-500 rounded-full flex items-center justify-center"
            style={{
              height: `${reserveCapacity}%`,
              background: `linear-gradient(to top, ${getDangerColor()}, ${getDangerColor()}aa)`,
            }}
          >
            {/* Percentage inside the bar */}
            <div className="text-white font-bold text-sm transform rotate-0">
              {reserveCapacity}%
            </div>
          </div>
        </div>
        <div className="text-sm text-center mt-4">
          <span style={{ color: getDangerColor() }}>
            {getDangerLevel().toUpperCase()}
          </span>
        </div>
        
        {/* Control buttons */}
        <div className="flex justify-center gap-2 mt-4">
          <button
            onClick={onPlayPause}
            className="bg-blue-600 hover:bg-blue-700 text-white p-2 rounded-lg transition-colors duration-200 flex items-center justify-center"
            title={isPlaying ? "Pause" : "Play"}
          >
            {isPlaying ? <Pause size={16} /> : <Play size={16} />}
          </button>
          <button
            onClick={onRestart}
            className="bg-green-600 hover:bg-green-700 text-white p-2 rounded-lg transition-colors duration-200 flex items-center justify-center"
            title="Restart"
          >
            <RotateCcw size={16} />
          </button>
        </div>
      </div>
      
      {/* Time to failure indicator */}
      <div className="bg-black/50 backdrop-blur-sm rounded-lg p-4 border border-gray-600">
        <div className="text-sm text-gray-300 font-bold mb-2 text-center">TIME TO FAILURE</div>
        <div className="text-2xl font-bold text-center text-white">
          {timeToFailure}mo
        </div>
      </div>
    </div>
  );
};

export default BatteryIndicators;